export enum EventType {
	ONE_TO_ONE = "ONE_TO_ONE",
	ONE_WAY = "ONE_WAY",
	TWO_WAY = "TWO_WAY",
}
